module.exports = __webpack_public_path__ + "static/img/zfb.8cd4847.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zfb.jpg
// module id = mwvW
// module chunks = 1